export default state => {
	console.info('🦑 CLEAR_CLAIM_DATA');
	state.claims = {};
};
